import React from 'react';

import PropTypes from 'prop-types';

import {
  Subtitle
} from '../../../StyledComponents';

import PersonIcon from '../../Common/Svg/PersonIcon';
import CellPhoneIcon from '../../Common/Svg/CellPhoneIcon';
import SuitCaseIcon from '../../Common/Svg/SuitCaseIcon';
import VettingGreenTickWithCircle from '../../Common/Svg/VettingGreenTickWithCircle';
import VettingEditIcon from '../../Common/Svg/VettingEditIcon';
import VettingHomeIcon from '../../Common/Svg/VettingHomeIcon';
import VettingCurrencyIcon from '../../Common/Svg/VettingCurrencyIcon';
import VettingPlainTick from '../../Common/Svg/VettingPlainTick';
import VettingPostalIcon from '../../Common/Svg/VettingPostalIcon';

import './VettingSectionHOC.css';

const VettingSectionHOC = (props) => {
  const getIcon = (logo) => {
      switch(logo){
        case 'PersonIcon': return <PersonIcon strokeColor = {props.showBody ? '#282828' : '#666666'}/>;
        case 'CellPhoneIcon': return <CellPhoneIcon strokeColor={props.showBody ? '#282828' : '#666666'}/>
        case 'SuitCaseIcon': return <SuitCaseIcon strokeColor={props.showBody ? '#282828' : '#666666'}/>
        case 'HomeIcon': return <VettingHomeIcon strokeColor={props.showBody ? '#282828' : '#666666'} />
        case 'CurrencyIcon': return <VettingCurrencyIcon strokeColor={props.showBody ? '#282828' : '#666666'} />
        case 'PlainTick': return <VettingPlainTick strokeColor={props.showBody ? '#282828' : '#666666'} />
        case 'PostalIcon': return <VettingPostalIcon strokeColor={props.showBody ? '#282828' : '#666666'} />
        default: return null;
      }
  }
  return(
    <div className={`vetting-section-wrapper`}>
      <div 
        className="vetting-section-header"
      >
        <div className="vetting-section-header-left">
          <div className="vetting-section-header-logo">
            {
              props.isDataAvailable ? 
                <VettingGreenTickWithCircle/>
                :
                <React.Fragment>
                  {getIcon(props.logo)}
                </React.Fragment>
            }
          </div>
          <Subtitle 
            style={{marginTop: 0}} 
            color={!props.showBody ? '#999999' : null}
            automationidattr = {props.title}
          >
            {props.title}
          </Subtitle>
        </div>
        {
          props.showBody && props.identifier !== 'creditCheck'? 
            props.isDataAvailable ? 
              <div 
                className="vetting-section-header-right"
                onClick={()=>props.onEditClick(props.identifier)}
                style={{ cursor: 'pointer'}}
                automationid={`SalesLead_Div_${props.identifier}Edit_1`}
              >
                <VettingEditIcon/> 
                <span 
                  className="vetting-edit-details-text"
                  automationid={`SalesLead_span_${props.identifier}EditText_1`}
                >
                  Edit details
                </span>
              </div>
              :
              <div 
                className="vetting-section-header-right"
                automationid={`SalesLead_div_${props.identifier}sectionOfText_1`}
              >
                {props.sectionOf}
              </div>
            :
            null
        }
      </div>
      {
        props.showBody ? 
          <div className="vetting-section-body">
            {props.children}
          </div>
        :
          null
      }
    </div>
  )
}

VettingSectionHOC.propTypes = {
  identifier: PropTypes.string,
  isDataAvailable: PropTypes.bool,
  logo: PropTypes.string,
  onEditClick: PropTypes.func,
  sectionOf: PropTypes.string,
  showBody: PropTypes.bool,
  title: PropTypes.string,
}

export default VettingSectionHOC;